import {
  createRouter,
  createWebHistory,
  type RouteLocationNormalized,
} from 'vue-router';
import { currentAccessToken } from './auth';

const sharedExampleProps = (route: RouteLocationNormalized) => ({
  id: String(route.params.id),
});

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./HomePage.vue'),
    },
    {
      path: '/app',
      name: 'dictionary-app',
      component: () => import('./DictionaryPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/s/:id([0-9a-fA-F-]{36})',
      name: 'shared-example',
      component: () => import('./SharedExamplePage.vue'),
      props: sharedExampleProps,
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('./NotFoundPage.vue'),
    },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !currentAccessToken()) {
    return {
      name: 'home',
      query: { redirect: to.fullPath },
    };
  }
  return true;
});
